import React from 'react';
import PropTypes from 'prop-types';
import { slugify } from 'bento-ordering/utils/slugify';
import { makeStyles } from '@material-ui/styles';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { isMobileMedia } from 'bento-ordering/utils/media';

const useStyles = makeStyles(theme => ({
  root: {
    outline: 'none'
  }
}));

const MenuSectionHeader = ({ title, isFirst }) => {
  const classes = useStyles();
  return (
    <Box pt={isFirst ? '30px' : '20px'} pb="16px" data-testid="menu-section">
      <Typography
        id={`${slugify(title)}-header`}
        variant="h2"
        classes={classes}
        tabIndex={!isMobileMedia() ? '-1' : undefined}
      >
        {title}
      </Typography>
    </Box>
  );
};

MenuSectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  isFirst: PropTypes.bool.isRequired
};

export default MenuSectionHeader;
